var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { t } from 'i18next';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseComponent } from '../../utils/BaseComponent';
import '../../components/tabs/tabs';
import '../../components/tabs/tab';
let PrivateListingHeader = class PrivateListingHeader extends BaseComponent {
    render() {
        return html `
      <trust-tabs key=${this.tabKey}>
        <trust-tab index="0" key=${this.tabKey}>
          <p class="strong">${t('Feedback received')}</p>
        </trust-tab>
        <trust-tab index="1" key=${this.tabKey}>
          <p class="strong">${t('Feedback given')}</p>
        </trust-tab>
      </trust-tabs>
    `;
    }
};
__decorate([
    property()
], PrivateListingHeader.prototype, "tabKey", void 0);
PrivateListingHeader = __decorate([
    customElement('trust-private-listing-header')
], PrivateListingHeader);
export { PrivateListingHeader };
//# sourceMappingURL=PrivateListingHeader.js.map